import { AxiosInstancePlus } from '@tencent/oneid-request';
import { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';
import BaseApi from 'common/http/BaseApi';

class OpenApi extends BaseApi {
  public axiosInstance: AxiosInstancePlus = http;

  public prefixURL = '/openapi/v2';

  /** 创建企业时，获取企业所在行业类型配置 */
  getIndustryTypes(): Promise<IResponseType<{ industryTypes: { id: string; name: string }[] }>> {
    return this.axiosInstance.get(`${this.prefixURL}/accounts/industry_types`);
  }
}

export default new OpenApi();
